import React from 'react';
import PropTypes from 'prop-types';
import { resolve } from '@cvent/nucleus-dynamic-css';
import removeKeys from '../utils/removeKeys';
import { resolveTestId } from '@cvent/nucleus-test-automation';
/**
DragHandle - A wrapper component to make the child content a handle for a draggable container.
Designed to be used as a direct child of a DragContainer component.
**/
const DragHandle = (props) => {
  const { dragStart, children, ...rest } = removeKeys(props, ['classes']);
  return (
    <div
      {...rest}
      {...resolveTestId(props)}
      {...resolve(props, 'dragHandle')} onMouseDown={dragStart} >
      {children}
    </div>
  );
};

DragHandle.propTypes = {
  /** Callback function to execute on mouse down (should start drag action).  */
  dragStart: PropTypes.func,
  /** The child content for the container. */
  children: PropTypes.node,
  /** Available Style Keys. */
  style: PropTypes.shape({
    /** Top level style applied to the container. */
    dragHandle: PropTypes.object
  })
};

DragHandle.displayName = 'DragHandle';
export default DragHandle;
